import {
  addSearchString,
  changeSearchFilter,
  clearPdfFile,
  hideLeftBar,
  hideRightBar,
  isShowSearchDetails,
  requestPdf,
  requestPdfFailed,
  requestPdfSuccess,
  requestRubric,
  requestRubricFailed,
  requestRubricSuccess,
  requestSearchResults,
  requestSearchResultsFailed,
  requestSearchResultsSuccess,
  setSearchValue,
} from '../actions/searchActions';
import { handleActions } from 'redux-actions';
import { responseToCorrectArray } from 'utils/search.utils';

const initialState = {
  authorSearch: '',
  changed: true,
  hasMore: true,
  isDisabled: true,
  isHideLeftBar: false,
  isHideRightBar: false,
  isShowSearchDetails: false,
  offlineSearchResults: null,
  pdf: null,
  periodFrom: null,
  periodTo: null,
  post: {
    authorUpperCase: [],
    fileName: '',
  },
  rubrics: [],
  searchContents: [],
  searchRequest: {},
  searchResults: [],
  searchValue: '',
  section: '',
  tagsArray: [],
  tagsInFocus: false,
  typePublication: '',
  types: [],
};

const searchHandler = {
  [addSearchString]: (state, { payload }) => {
    return { ...state, searchRequest: payload };
  },
  [changeSearchFilter]: (state, { payload }) => {
    return { ...state, changed: true, ...payload };
  },
  [clearPdfFile]: (state) => {
    return { ...state, pdf: null };
  },
  [hideLeftBar]: (state, { payload }) => {
    return { ...state, isHideLeftBar: payload.isHideLeftBar };
  },
  [hideRightBar]: (state, { payload }) => {
    return { ...state, isHideRightBar: payload.isHideRightBar };
  },
  [isShowSearchDetails]: (state, { payload }) => {
    return { ...state, isShowSearchDetails: payload.isShowSearchDetails };
  },
  [requestPdf]: (state) => {
    return { ...state, loading: true };
  },
  [requestPdfFailed]: (state, { message }) => {
    return { ...state, error: true, errorText: message, loading: false };
  },
  [requestPdfSuccess]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      pdf: payload,
    };
  },
  [requestRubric]: (state) => {
    return { ...state, loading: true };
  },
  [requestRubricFailed]: (state, { message }) => {
    return { ...state, error: true, errorText: message };
  },
  [requestRubricSuccess]: (state, { payload }) => {
    const data = payload.data;
    const arr = data.map((item) => ({
      num: item.num,
      term: item.term,
    }));
    if (payload.cls === 39) {
      return { ...state, rubrics: arr };
    } else {
      return { ...state, types: arr };
    }
  },
  [requestSearchResults]: (state) => {
    return { ...state, loading: true };
  },
  [requestSearchResultsFailed]: (state, { message }) => {
    return { ...state, error: true, errorText: message };
  },
  [requestSearchResultsSuccess]: (state, { payload }) => {
    const { data, mode, isBrowserOnline } = payload;
    let responseArray = [];

    if (data[0] && isBrowserOnline === undefined) {
      responseArray = responseToCorrectArray(data);
    }
    if (!data[0] && mode === 'append') {
      return { ...state, hasMore: false, searchResults: state.searchResults.concat(responseArray) };
    }
    if (mode === 'append') {
      return { ...state, searchResults: state.searchResults.concat(responseArray) };
    }
    if (mode === 'replace') {
      if (isBrowserOnline !== undefined && !isBrowserOnline) {
        return { ...state, offlineSearchResults: data };
      }
      return { ...state, searchResults: responseArray };
    }
  },
  [setSearchValue]: (state, { payload }) => {
    return { ...state, isDisabled: false, searchValue: payload };
  },
};

const searchReducer = handleActions(searchHandler, initialState);

export default searchReducer;
